// import { ErrorMessage } from "formik";
import { Checkbox, Input, Select, TimePicker } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import dayjs from "dayjs";
import { ReactElement, useEffect, useState } from "react";
import styled, { CSSProperties } from "styled-components";

import { StyledError } from "@components";
import { IHandleBlur, IHandleChange, IHandleChangeSelect, ISelect } from "@interfaces";
import { validNationalID } from "@utils";
import { LazyMotion, domAnimation, m } from "framer-motion";
import useForm from "src/Store/useForm";

const { Option } = Select;
interface IProps {
    name?: string;
    label?: string;
    descLabel?: string;
    value?: string | number;
    className?: string;
    style?: CSSProperties | undefined;
    styleParent?: CSSProperties | undefined;
    onChange?: IHandleChange;
    onBlur?: IHandleBlur;
    onClick?: () => void;
    type?: string;
    prefixIcon?: ReactElement;
    suffixIcon?: ReactElement;
    notFormik?: boolean;
    placeholder?: string;
    err?: string;
    notErr?: boolean;
    disable?: boolean;
    errors?: string | undefined;
    touched?: boolean | undefined;
    defaultValue?: string | number;
    length?: number | undefined;
}

export const SharedInput = (props: IProps) => {
    //page props
    const {
        name,
        style,
        onChange,
        onBlur,
        onClick,
        value,
        type,
        prefixIcon,
        suffixIcon,
        // notFormik,
        placeholder,
        className,
        notErr,
        disable,
        errors,
        touched,
        label,
        descLabel,
        styleParent,
        defaultValue,
        length,
    } = props;

    const [isFocus, setFocus] = useState(false);
    const [isError, setError] = useState("");

    useEffect(() => {
        if (name === "id_card") {
            console.log(value?.toString().length);
            if (value) {
                if (value?.toString().length < 13) {
                    console.log("ERROR 13");
                    setError("ID must be 13 characters");
                    useForm.setState({ ID: false });
                    return;
                } else if (!validNationalID(value?.toString())) {
                    setError("ID is incorrect.");
                    useForm.setState({ ID: false });
                    return;
                }

                setError("");
                useForm.setState({ ID: true });
            }
        }
        // if (name === "fullname") {

        // }
    }, [value]);

    return (
        <StyledContainer style={styleParent}>
            {label && (
                <label htmlFor={name} className="label">
                    {label}
                    <span>{descLabel}</span>
                </label>
            )}
            <Panel>
                <Input
                    id={name}
                    className={errors && touched ? `${className} input-invalid` : className}
                    type={type}
                    name={name}
                    value={value}
                    style={{ ...style }}
                    onChange={onChange}
                    maxLength={length}
                    onBlur={(e) => {
                        if (onBlur) onBlur(e);
                        setFocus(false);
                    }}
                    onClick={() => {
                        if (onClick) onClick();
                        setFocus(true);
                    }}
                    prefix={prefixIcon}
                    suffix={suffixIcon}
                    // placeholder={placeholder}
                    disabled={disable}
                    defaultValue={defaultValue}
                />
                <Placeholder {...{ placeholder, isFocus, style, value }} />
            </Panel>
            <StyledError className="custom-error" visible={isError !== "" ? true : false}>
                {isError}
            </StyledError>
            {/* {!notErr && (
                <StyledError className="custom-error" visible={!!(errors && touched)}>
                    {errors || "errors"}
                </StyledError>
            )} */}
            {errors && (
                <StyledError className="custom-error" visible={true}>
                    {errors || "errors"}
                </StyledError>
            )}
            {/* <ErrorMessage name={name} component={StyledError} /> */}
        </StyledContainer>
    );
};

const Placeholder = ({ placeholder, isFocus, style, value }: any) => {
    const hasValue = value !== "" && value !== undefined ? true : false;
    const trigger = isFocus || hasValue;
    return (
        <>
            {placeholder && (
                <LazyMotion features={domAnimation}>
                    <PlaceholderContainer
                        initial={{
                            fontSize: "13px",
                            lineHeight: "27px",
                            left: "4px",
                            color: "rgba(0,0,0,0.3)",
                            textOverflow: "ellipsis",
                        }}
                        animate={{
                            color: trigger ? "rgba(0,0,0,0.8)" : "rgba(0,0,0,0.3)",
                            fontSize: trigger ? "11px" : "13px",
                            top: trigger ? "-14px" : "",
                            left: trigger ? "10px" : "4px",
                            backgroundColor: trigger
                                ? "rgba(255,255,255,1)"
                                : "rgba(255,255,255,0)",
                        }}
                        style={{ ...style, padding: "0 10px", borderRadius: "12px" }}
                    >
                        {placeholder}
                    </PlaceholderContainer>
                </LazyMotion>
            )}
        </>
    );
};

const PlaceholderContainer = styled(m.div)`
    position: absolute;
    left: 20px;
    pointer-events: none;
`;

const Panel = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledContainer = styled.div`
    .input-add-contact {
        height: 48px;
        input {
            font-size: 16px;
        }
    }
    input {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
    }

    input::placeholder {
        color: #bfbfbf !important;
        font-size: 16px;
    }
    input {
        /* border-color: #d9d9d9 !important; */
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        /* border: none; */
    }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type="number"] {
        appearance: textfield;
        -moz-appearance: textfield;
    }
    .input-invalid {
        input {
            border-width: 1px;
            border-color: ${(p) => p.theme.colors.danger}!important;
            &:focus-within {
                border-color: ${(p) => p.theme.colors.danger}!important;
            }
        }
        .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled),
        .ant-input:focus,
        .ant-input:hover,
        .ant-select-selection:hover,
        .ant-select-selection:focus,
        .ant-select-selection:focus-within {
            border-width: 1px;
            border-color: ${(p) => p.theme.colors.danger}!important;
        }
    }
    .height_48 {
        .ant-input {
            height: 48px;
        }
    }
    .label {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 21px;
        color: #000000;
        margin-bottom: 8px;
        display: inline-block;
        @media (max-width: ${(p) => p.theme.breakPoints.breakOnlyMobile}) {
            font-size: 14px;
            margin-bottom: 6px;
        }
        span {
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: #6c7084;
            display: inline-block;
            margin-left: 12px;
        }
    }
    .ant-input-prefix {
        font-size: 20px !important;
        svg {
            margin-bottom: 2px;
        }
    }
    .ant-input-affix-wrapper .ant-input:not(:first-child) {
        padding-left: 50px;
        background-color: #f7f7f8;
        border-radius: 6px;
    }
    /* .ant-input {
        background-color: #f7f7f8;
    } */
    svg[data-icon="phone"] {
        transform: rotate(90deg);
    }
`;

interface IPropTime {
    onChange?: (time: dayjs.Dayjs, timeString?: string | string[]) => void;
    time: string;
}
const format = "HH:mm";
export const SharedTime = (props: IPropTime) => {
    const { onChange, time } = props;
    return (
        <StyledTimeContainer>
            <TimePicker defaultValue={dayjs(time, format)} format={format} onChange={onChange} />
        </StyledTimeContainer>
    );
};

const StyledTimeContainer = styled.div`
    display: inline-block;
    width: 100%;
    .ant-time-picker-icon,
    .ant-time-picker-clear {
        right: 12px !important;
    }
    .ant-time-picker-input {
        height: ${(p) => p.theme.heights.input};
        font-size: 16px;
    }
    .ant-time-picker-input:hover {
        border-color: #d9d9d9 !important;
    }
    .anticon.anticon-close-circle.ant-time-picker-clear {
        display: none !important;
    }
`;

interface IPropsSelect {
    name?: string;
    className?: string;
    label?: string;
    style?: CSSProperties;
    styleParent?: CSSProperties;
    data: Array<ISelect>;
    onChange: IHandleChangeSelect;
    defaultValue?: string;
    value?: string;
    placeholder?: string;
    type?: "multiple" | "tags";
    errors?: string | undefined;
    touched?: boolean | undefined;
}

export const SharedSelect = (props: IPropsSelect) => {
    const { label, name, styleParent, data, onChange, errors, touched, value, placeholder } = props;

    return (
        <StyledSelect style={styleParent} isError={!!(errors && touched)}>
            {label && (
                <label htmlFor={name} className="label">
                    {label}
                </label>
            )}
            <fieldset name={name} key={name}>
                <Select onChange={onChange} value={value} placeholder={placeholder}>
                    {data.map((item) => {
                        return (
                            <Option value={item.id} key={item.id}>
                                {item.label}
                            </Option>
                        );
                    })}
                </Select>
                {errors && touched && (
                    <StyledError visible={true}>{errors || "errors"}</StyledError>
                )}
            </fieldset>
        </StyledSelect>
    );
};

const StyledSelect = styled.div<{ isError?: boolean }>`
    .label {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 21px;
        color: #000000;
        margin-bottom: 8px;
        display: block;
        @media (max-width: ${(p) => p.theme.breakPoints.breakOnlyMobile}) {
            font-size: 14px;
            margin-bottom: 6px;
        }
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        align-items: start;
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection__rendered {
        max-width: 100%;
    }
    ${(p) => {
        if (p.isError)
            return `
        .ant-select-selection {
                border-width: 1px;
                border-color: ${p.theme.colors.danger}!important;
                &:focus-within {
                    border-color: ${p.theme.colors.danger}!important;
                }
            }
        `;
    }}
`;

interface ICheckBox {
    name: string;
    value: boolean;
    onChange: ((e: CheckboxChangeEvent) => void) | undefined;
    label?: string | JSX.Element;
    errors?: string | undefined;
    touched?: boolean | undefined;
}

export const SharedCheckBox = (props: ICheckBox) => {
    const { name, value, onChange, label, errors, touched } = props;
    return (
        <>
            <Checkbox name={name} value={value} checked={value} onChange={onChange}>
                {label}
            </Checkbox>
            {errors && touched && <StyledError visible={true}>{errors}</StyledError>}
        </>
    );
};
